/**
 * Web-search / knowledge pipelines sometimes leak internal citation routing tokens into the
 * visible answer (e.g. `[cite][turn0search0]` or `[]cite[]turn0commentaryto=functions.searchPages0[]`).
 * They are not valid markdown and should not appear in the UI.
 */

const AGENT_CONTEXT_BLOCK_RE =
  /<!-- agent-context-block-start -->[\s\S]*?<!-- agent-context-block-end -->/g;
const DYNAMIC_CONTEXT_RE = /<dynamic_context>[\s\S]*?<\/dynamic_context>/gi;
const OPEN_VIEW_AUTO_TOOL_RE =
  /<open_view_auto_tool>[\s\S]*?<\/open_view_auto_tool>/gi;
const USER_INPUT_START_RE = /<!-- user-input-start -->\n?/g;
const USER_INPUT_END_RE = /\n?<!-- user-input-end -->/g;
const OPEN_VIEW_MARKER_RE =
  /<!-- open_view key="[^"]*" hash="[a-f0-9]+" -->/g;

/** Prompt envelopes the model sometimes copies into the assistant bubble. */
export function stripLeakedAssistantPromptEnvelopes(text: string): string {
  return text
    .replace(AGENT_CONTEXT_BLOCK_RE, "")
    .replace(DYNAMIC_CONTEXT_RE, "")
    .replace(OPEN_VIEW_AUTO_TOOL_RE, "")
    .replace(USER_INPUT_START_RE, "")
    .replace(USER_INPUT_END_RE, "")
    .replace(OPEN_VIEW_MARKER_RE, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

export function stripLeakedAssistantCitationPlaceholders(text: string): string {
  return (
    text
      // Legacy bracket pairs: [cite][turn0search0]
      .replace(/(?:\[(?:cite|turn\d+search\d+)\][ \t]*)+/gi, "")
      // Provider commentary routing: []cite[]turn0commentaryto=functions.searchPages0[]
      .replace(
        /(?:\[\]?[ \t]*cite[ \t]*\[\]?[ \t]*)?turn\d+commentary\w*(?:=functions\.\w+\d*)?[ \t]*\[\]?/gi,
        "",
      )
      // Orphan cite markers if the turn token was already stripped
      .replace(/\[\]?[ \t]*cite[ \t]*\[\]?/gi, "")
  );
}

export function sanitizeVisibleAssistantText(text: string): string {
  return stripLeakedAssistantCitationPlaceholders(
    stripLeakedAssistantPromptEnvelopes(text),
  );
}
